import React, { useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import '../layout/sass/_form.scss';

/* eslint-disable array-callback-return */

export const FormRomaneioItens = ({ isEditing, isLoading, visible, setVisible, romaneioItens, setRomaneioItens, produtos, mensagem, setMensagem }) => {
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const schema = Yup.object().shape({
        quantidade: Yup
            .number()
            .required("A quantidade é obrigatório")
            .max(10000, "A quantidade dete ter no máximo 10 caracteres"),
        produtoId: Yup
            .number()
            .required("O produto é obrigatório")
            .positive("O produto deve ser selecionado")
            .integer("O produto deve estar na lista")
    })

    const formik = useFormik({

        initialValues: {
            "id": 0,
            "produtoId": 0,
            "produtoNome": "",
            "quantidade": 0,
            "romaneioId": 0,
            "itensId": ""
        },

        validationSchema: schema,

        enableReinitialize: false,

        onSubmit: (data) => {
            setIsSubmiting(true)

            let produtoNome
            let itensId

            produtos.map((p) => {

                if (p.id === data.produtoId) {
                    produtoNome = p.produtoNome
                    itensId = p.itensId
                }

            })

            data.produtoNome = produtoNome;
            data.itensId = itensId;

            setRomaneioItens(romaneioItens => [...romaneioItens, data]);

            setIsSubmiting(false)
        }
    })

    const handleSubmit = () => {
        setIsSubmiting(true)
        let produtoNome
        let itensId
        let quantidade
        let produtoId
        let prod
        if (produtos !== "") {
            if (produtos.length === 1) {
                produtos.map(produto => {
                    prod = [
                        produtoId = produto.id,
                        produtoNome = produto.produtoNome,
                        itensId = produto.itensId,
                        quantidade = 0
                    ]
                })
                prod.produtoId = produtoId;
                prod.produtoNome = produtoNome;
                prod.itensId = itensId;
                prod.quantidade = quantidade;

                setRomaneioItens(romaneioItens => [...romaneioItens, prod]);
                produtos.length = produtos.length - 1;
            }
            else {
                produtos.map(produto => {
                    prod = [
                        produtoId = produto.id,
                        produtoNome = produto.produtoNome,
                        itensId = produto.itensId,
                        quantidade = 0
                    ]
                })
                prod.produtoId = produtoId;
                prod.produtoNome = produtoNome;
                prod.itensId = itensId;
                prod.quantidade = quantidade;
                setRomaneioItens(romaneioItens => [...romaneioItens, prod]);
                produtos.length = produtos.length - 1;
                handleSubmit();
            }
        }

        setIsSubmiting(false)
    }    

    return (

        <Fieldset legend="Itens" toggleable  >
            <h2><b>Importante:</b> Para criar/atualizar o romaneio é necessário ter ao menos 1 produto no prazo vigente vinculado.</h2>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">

                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="produto"
                                    className={classNames({ 'p-error': isFormFieldValid('produto') })}
                                >
                                    Produto
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="produtoId"
                                            name="produtoId"
                                            options={produtos}
                                            filter={true}
                                            emptyMessage={mensagem !== "" ? mensagem : "Nenhum produto encontrado"}
                                            optionLabel="produtoNome"
                                            optionValue="id"
                                            placeholder="Selecione um produto"
                                            className={classNames({ 'p-invalid': isFormFieldValid('produtoId') })}
                                            value={formik.values.produtoId}
                                            onChange={option => formik.setFieldValue("produtoId", option.value)}
                                            //onChange={handleChange}
                                            emptyFilterMessage={mensagem !== "" ? mensagem : "Nenhum produto encontrado"}
                                            disabled={produtos === ''}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.produtoId && formik.touched.produtoId &&
                                    <ErrorValidationMessage message={formik.errors.produtoId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="quantidade"
                                    className={classNames({ 'p-error': isFormFieldValid('quantidade') })}
                                >
                                    Quantidade
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="quantidade"
                                            name="quantidade"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('quantidade') })}
                                            value={formik.values.quantidade}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.quantidade && formik.touched.quantidade &&
                                    <ErrorValidationMessage message={formik.errors.quantidade} />
                                }
                            </div>

                            <div className="p-d-flex p-jc-end p-mr-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    onClick={formik.handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-d-flex p-jc-end p-mr-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    tooltip='Adicionar todos os produtos'
                                    className="p-button-success"
                                    onClick={handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-formgrid p-grid p-fluid p-mx-0">

                            </div>

                        </div>

                    </form>
                </div>
            </div>

        </Fieldset>

    );
}
